import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faTelegram, faTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faRainbow, faSms, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';

function ChannelIcon(props) {

    const getIcon = () => {

        let elem = <FontAwesomeIcon size='2x' icon={duotone("messages")} />;
        let channel = "";

        if (props.channel !== null)
            channel = props.channel.toLowerCase();

        if (channel === "facebook")
            elem = <FontAwesomeIcon size='2x' icon={faFacebook} />;
        if (channel === "whatsapp")
            elem = <FontAwesomeIcon size='2x' icon={faWhatsapp} />;
        if (channel === "instagram")
            elem = <FontAwesomeIcon size='2x' icon={faInstagram} />;
        if (channel === "twitter")
            elem = <FontAwesomeIcon size='2x' icon={faTwitter} />;
        if (channel === "sms")
            elem = <FontAwesomeIcon size='2x' icon={faSms} />;
        if (channel === "telegram")
            elem = <FontAwesomeIcon size='2x' icon={faTelegram} />;
        if (channel === "rainbow")
            elem = <FontAwesomeIcon size='2x' icon={faRainbow} />;
        if (channel === "mail")
            elem = <FontAwesomeIcon size='2x' icon={faEnvelope} />;
        
        return <span className="fw-bold text-primary text-center" >{elem}</span>;
    }


    return (<>  {getIcon()}</>
    );
}

export default ChannelIcon;